import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  events: localStorage.getItem('events') && localStorage.getItem('events') || []
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/test/index.js